import type { ReactNode } from "react";
import { Layers } from "lucide-react";

import { useT } from "../../i18n";
import { useLayersStore } from "../../store/layersStore";
import { Checkbox } from "../ui/Checkbox";
import { FloatingPanel } from "../layout/FloatingPanel";

function GroupTitle({ children }: { children: ReactNode }) {
  return (
    <h3 className="mb-1 mt-3 text-xs font-semibold uppercase tracking-wide text-text-tertiary first:mt-0">
      {children}
    </h3>
  );
}

export function LayersPanel() {
  const t = useT();
  const { flags, toggleLayer, rasterOpacity, setRasterOpacity } = useLayersStore();

  return (
    <FloatingPanel
      icon={<Layers size={16} />}
      title={t.layers.title}
      openLabel={t.layers.open}
      collapseLabel={t.layers.collapse}
    >
      <GroupTitle>{t.layers.groupBorders}</GroupTitle>
      <Checkbox
        checked={flags.country}
        onChange={() => toggleLayer("country")}
        label={t.layers.country}
      />
      <Checkbox
        checked={flags.regions}
        onChange={() => toggleLayer("regions")}
        label={t.layers.regions}
      />

      <GroupTitle>{t.layers.groupData}</GroupTitle>
      <Checkbox
        checked={flags.plumes}
        onChange={() => toggleLayer("plumes")}
        label={t.layers.plumes}
      />
      <Checkbox
        checked={flags.raster}
        onChange={() => toggleLayer("raster")}
        label={t.layers.raster}
      />
      <div className="mb-1 ml-6 mt-0.5">
        <input
          type="range"
          min={0}
          max={1}
          step={0.05}
          value={rasterOpacity}
          onChange={(e) => setRasterOpacity(Number(e.target.value))}
          disabled={!flags.raster}
          aria-label={t.layers.rasterOpacity}
          className="w-full accent-accent disabled:opacity-40"
        />
        <p className="text-xs leading-tight text-text-tertiary">
          {t.layers.rasterPending}
        </p>
      </div>
      <Checkbox
        checked={flags.sources}
        onChange={() => toggleLayer("sources")}
        label={t.layers.sources}
      />
      <Checkbox
        checked={flags.aoi}
        onChange={() => toggleLayer("aoi")}
        label={t.layers.aoi}
      />
    </FloatingPanel>
  );
}
